import * as React from 'react'

import { Grid } from '~ui/components/layout/Box'

import { AppliedPromoCodes } from './components/AppliedPromoCodes'
import { PromoInput } from './components/PromoInput'
import { PromoCodeProvider } from './contexts/PromoCodeProvider'

type TPromoCodeProviderProps = Pick<PropsOf<typeof PromoCodeProvider>, 'refetchQueries'>
type TProps = NoChildren & TPromoCodeProviderProps

/**
 * Form order promo code input.
 * Renders an input for adding new promo codes,
 * and a list of applied promo codes,
 * and wraps both in the provider holding the promo state.
 */
export const PromoCodes: React.FC<TProps> = ({ refetchQueries }) => {
  return (
    <PromoCodeProvider refetchQueries={refetchQueries}>
      <Grid rowGap={`medium`}>
        <PromoInput />
        <AppliedPromoCodes />
      </Grid>
    </PromoCodeProvider>
  )
}
